/*
    Directive to set focus on inputs.
    Just add "v-focus-input" to any element ui input and it will autofocus.
    This will not work on elements inside a "v-show", but will work on elements inside a "v-if".
 */

import Vue from 'vue';

Vue.directive('focus-input', {
    bind(el, binding, vNode) {
        let component = vNode.componentInstance;

        if (!component) return;

        $(el).find('input, textarea').attr('autofocus');

        component.$nextTick(() => {
            $(el).find('input, textarea').focus();
        })

        bindFocusEventToParent(component, component);
    },

    unbind(el, binding, vNode) {
        vNode.componentInstance.$nextTick(() => {
            $(el).find('input, textarea').removeAttr('autofocus');
        })
    }
});

/**
 * Finds the parent slideout/modal in order to attach an "open" event listener so we can reset focus
 * on the input each time the parent is opened.
 *
 * @param {object} component - component to use for recursion to find the parent container
 * @param {object} originalComponent - copy of the original component that contains the input to focus
 */
function bindFocusEventToParent(component, originalComponent) {
    let parent;

    if (!component) return;

    if (
        component.$options.name != 'slideout' &&
        component.$options.name != 'ElDialog' &&
        component.$options.name != 'ElDrawer'
    ) {
        parent = bindFocusEventToParent(component.$parent, originalComponent);
    } else {
        component.$on('open', () => {
            originalComponent.$nextTick(() => {
                $(originalComponent.$el).find('input, textarea').focus();
            })
        })
    }
}